export enum Routes {
  Root = '/',
  Login = '/login',
  Users = '/users',
  UserDetails = '/users/:id',
  Logs = '/logs',
}

export const AuthRoutes = [Routes.Login];
